export enum RowSpacing {
    Normal,
    Large,
    Small
}